/**
 * Editorial no-CTA lock — DISABLED (2026-08).
 *
 * Home global is `BaseTemplate.tsx` for all countries (site-settings).
 * Hero CTAs come from CTA por región / Worker flags — not stripped by country list.
 *
 * Keep helpers so call sites compile; they always return false / empty set.
 * Worker: empty `EDITORIAL_HOME_NO_CTA_COUNTRIES` must stay in sync.
 */

/** Empty — no country is forced off CTA / Dual / black shell. */
export const EDITORIAL_HOME_NO_CTA_COUNTRIES = new Set<string>();

export function isEditorialHomeNoCtaCountry(_code?: string | null): boolean {
  return false;
}
